<div class="notification-icon-section" (click)="openNotifications()">
    <svg height="40px" viewBox="0 0 24 24" width="40px" fill="#FFFFFF">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
    </svg>
</div>

<div class="notifications-container" *ngIf="show_notifiucations">
    <div class="notifications-section">
        <div class="notification-heading-section">
            <span>Notifications</span>
            <div>
                <span class="notification-close-icon" (click)="closeNotifications()">&times;</span>
            </div>
        </div>
        <div class="notification-content-section">
            <ng-container *ngIf="notifications_data_loaded">
                <div *ngIf="notifications_data['gen_notifications'].length > 0">
                    <div class="notification-card" *ngFor="let notification of notifications_data['gen_notifications']">
                        <div class="notification-card-icon">
                            <svg viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
                            </svg>
                        </div>

                        <div class="notification-details">
                            <p class="notification-title">{{notification.title}}</p>
                            <p class="notification-description"[innerHTML]="notification.content"></p>
                            <p class="notification-time">{{notification.fired_date | date: 'MMM d, y, h:mm a'}}</p>
                        </div>
                    </div>
                </div>
                <div class="notification-zero-state" *ngIf="notifications_data['gen_notifications'].length == 0">
                    <span>No Notifications Found</span>
                </div>
            </ng-container>
            <ng-container *ngIf="!notifications_data_loaded">
                <app-loader [loading_text]="'Loading Notifications'"></app-loader>
            </ng-container>
        </div>
    </div>
</div>